import type { Ref } from "vue";
import { readonly, ref } from "vue";

export interface AuthorizationToken {
  server: string;
  token_name: string;
  token: string;
  username: string;
  uid: number;
}

const key = "authorizationTokens";

function readAuthorizationTokens(): AuthorizationToken[] {
  const item = localStorage.getItem(key);
  if (!item) {
    return [];
  }
  let parsed: unknown;
  try {
    parsed = JSON.parse(item);
  } catch (error) {
    console.error("Cannot parse JSON", item, error);
    return [];
  }
  if (
    parsed === undefined ||
    parsed === null ||
    !(typeof parsed === "object")
  ) {
    return [];
  }
  // TODO: check that parsed is a valid array of tokens
  return parsed as AuthorizationToken[];
}

export function setAuthorizationToken(token: AuthorizationToken | undefined) {
  if (!token) {
    authorizationToken.value = undefined;
    return;
  }
  const tokens = readAuthorizationTokens().filter(
    (t) => t.server !== token.server,
  );
  tokens.push(token);
  authorizationToken.value = token;
  authorizationTokens.value = tokens;
  localStorage.setItem(key, JSON.stringify(tokens));
}

const authorizationToken: Ref<AuthorizationToken | undefined> = ref();
export const currentAuthorizationToken = readonly(authorizationToken);

const authorizationTokens: Ref<AuthorizationToken[]> = ref([]);
export const currentAuthorizationTokens = readonly(authorizationTokens);

function init() {
  const tokens = readAuthorizationTokens();
  authorizationTokens.value = tokens;
  for (const token of tokens) {
    authorizationToken.value ??= token;
  }
}
init();
